// Remove local token manager and always use the global one
document.addEventListener('DOMContentLoaded', function() {
    let bonusOfferList = document.getElementById('bonus-offer__list');
    if (bonusOfferList) {
        bonusOfferList.setAttribute('data-pagination', '12');
    }
});

// Add this global variable to store page cursors
const pageCursors = {};
const bonusOfferList = document.getElementById('bonus-offer__list');
const postPerPage = bonusOfferList.getAttribute('data-pagination') || 5;

// Add this global variable to store total items estimate
const storeInfo = {
  totalItems: 0,
  estimatedPages: 0
};

// Add filter options object to store available filter values
const filterOptions = {
  brands: [],
  categories: [],
  brandLabels: {},
  categoryLabels: {}
};

// Add this global variable to store all fetched data
const appState = {
  allMetaobjects: [],
  filteredMetaobjects: [],
  currentPage: 1,
  itemsPerPage: postPerPage, // default, will be updated from DOM
  filters: {
    brand: [],
    category: []
  }
};

// Add mobile UI state variables
const uiState = {
  isFilterOpen: false
};

// Modify layout constants to remove min-height values
const layoutConstants = {
  loadingDelay: 300 // milliseconds for minimum loading time to prevent flashing
};

// Add utility functions for debounce and throttle to prevent flickering
// IMPORTANT: Define this before any functions that use it
const utilityFunctions = {
  // Debounce function to prevent rapid firing of events
  debounce: (func, delay) => {
    let debounceTimer;
    return function(...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  },

  // Throttle function to limit the rate of function execution
  throttle: (func, limit) => {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
};

// Add utility function to convert between GID and clean ID
const urlUtils = {
  // Convert GID to clean ID for URL
  gidToCleanId: (gid) => {
    if (typeof gid === 'string') {
      // Handle Brand GIDs
      if (gid.startsWith('gid://shopify/Brand/')) {
        return gid.replace('gid://shopify/Brand/', '');
      }
      // Handle Category GIDs
      if (gid.startsWith('gid://shopify/Category/')) {
        return gid.replace('gid://shopify/Category/', '');
      }
      // Handle Collection GIDs (legacy support)
      if (gid.startsWith('gid://shopify/Collection/')) {
        return gid.replace('gid://shopify/Collection/', '');
      }
    }
    return gid;
  },

  // Convert clean ID back to Brand GID
  cleanIdToBrandGid: (cleanId) => {
    if (typeof cleanId === 'string' && !cleanId.startsWith('gid://')) {
      return `gid://shopify/Brand/${cleanId}`;
    }
    return cleanId;
  },

  // Convert clean ID back to Category GID
  cleanIdToCategoryGid: (cleanId) => {
    if (typeof cleanId === 'string' && !cleanId.startsWith('gid://')) {
      return `gid://shopify/Category/${cleanId}`;
    }
    return cleanId;
  }
};

// Add a global variable to track our initial data processing
let initialDataProcessing = null;

// Function to process metaobjects data from Liquid (replaces fetchMetaobjects)
function processMetaobjectsData() {
  try {
    // Get data from Liquid that was injected into the page
    const metaobjectsData = window.METAOBJECT_DATA;

    if (!metaobjectsData) {
      console.warn('No metaobject data available from Liquid');
      return {
        metaobjects: {
          edges: []
        }
      };    }

    // Handle different possible data structures from Liquid
    let dataArray = [];

    if (Array.isArray(metaobjectsData)) {
      dataArray = metaobjectsData;
    } else if (metaobjectsData.values && Array.isArray(metaobjectsData.values)) {
      dataArray = metaobjectsData.values;
    } else if (metaobjectsData.edges && Array.isArray(metaobjectsData.edges)) {
      // Already in GraphQL format
      return {
        metaobjects: metaobjectsData
      };
    } else {
      console.warn('Unexpected metaobject data structure:', metaobjectsData);
      return {
        metaobjects: {
          edges: []
        }
      };    }

    // Transform the Liquid data to match the expected GraphQL format
    const transformedData = {      metaobjects: {
        edges: dataArray.map((metaobject, index) => {
          // The metaobject from Liquid should have properties directly
          // We need to convert them to the fields format that the rest of the code expects
          let fields = [];// Convert metaobject properties to fields array
          if (metaobject && typeof metaobject === 'object') {
            Object.keys(metaobject).forEach(key => {
              // Skip system properties and ensure we have valid values
              if (!['id', 'handle', 'type', 'created_at', 'updated_at'].includes(key) &&
                metaobject[key] !== null &&
                metaobject[key] !== undefined) {
                const value = metaobject[key];
                let fieldType = 'single_line_text_field';
                let processedValue = value;
                // Handle special field structures from Liquid
                if (typeof value === 'object' && value !== null) {
                  if (value.type === 'rich_text_field') {
                    fieldType = 'rich_text_field';
                  } else if (value.reference) {
                    fieldType = 'file_reference';
                  } else if (value.id && value.title) {
                    // Handle brand/category objects with direct id and title properties
                    // For brand/category: { id: "gid://shopify/Brand/123", title: "Brand Name" } → "gid://shopify/Brand/123"
                    processedValue = value.id; // Use the ID for filtering
                    fieldType = 'collection_reference';
                  } else if (value.value) {
                    // Handle other objects with .value property
                    if (typeof value.value === 'object' && value.value.title) {
                      processedValue = value.value.title;
                      fieldType = 'collection_reference';
                    } else {
                      processedValue = value.value;
                    }
                  }
                } else if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/)) {
                  fieldType = 'date';
                }

                fields.push({
                  key: key,
                  value: processedValue,
                  type: fieldType,
                  // Store original object for reference if needed
                  ...(typeof value === 'object' && value !== null && value.value ? { originalValue: value } : {})
                });
              }
            });
          }
          // Ensure we always have at least an empty fields array
          if (!Array.isArray(fields)) {
            fields = [];
          }

          const processedNode = {
            node: {
              id: metaobject.id || `temp-${Math.random()}`,
              handle: metaobject.handle || '',
              fields: fields || [] // Ensure fields is always an array
            }
          };

          return processedNode;
        })
      }    };

    return transformedData;
  } catch (error) {
    console.error('Error processing metaobjects data:', error);
    // Return empty structure to prevent further errors
    return {
      metaobjects: {
        edges: []
      }
    };
  }
}

// Function to extract brand and category data directly from metaobject data
function extractBrandCategoryData(metaobjectsData) {
  const brandMap = {};
  const categoryMap = {};

  if (Array.isArray(metaobjectsData)) {
    metaobjectsData.forEach((offer) => {
      // Extract brand data if available
      if (offer.brand && offer.brand.id && offer.brand.title) {
        brandMap[offer.brand.id] = offer.brand.title;
      }

      // Extract category data if available
      if (offer.category && offer.category.id && offer.category.title) {
        categoryMap[offer.category.id] = offer.category.title;
      }
    });
  }

  return { brandMap, categoryMap };
}

// Update the extractFilterOptions function to use direct brand/category data
function extractFilterOptions(metaobjects) {
  const brands = new Set();
  const categories = new Set();

  // 1. Get string values from URL Params
  const urlParams = new URLSearchParams(window.location.search);
  const urlCategoryRaw = urlParams.get('category'); // Example: "12345,67890"
  const urlBrandRaw = urlParams.get('brand');       // Example: "443595358440,443597193448"

  // 2. Convert strings into arrays of numeric IDs (comma-separated)
  // If param exists, split it into an array; otherwise, initialize an empty array
  const urlCategoryIds = urlCategoryRaw ? urlCategoryRaw.split(',') : [];
  const urlBrandIds = urlBrandRaw ? urlBrandRaw.split(',') : [];

  // Extract name mapping data from the global variable
  const { brandMap, categoryMap } = extractBrandCategoryData(window.METAOBJECT_DATA);

  if (metaobjects && metaobjects.edges && Array.isArray(metaobjects.edges)) {
    metaobjects.edges.forEach((edge) => {
      const fields = {};
      if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
        edge.node.fields.forEach((field) => {
          if (field && field.key && field.value) {
            fields[field.key] = field.value;
          }
        });
      }

      // --- MULTI-SELECT CROSS-DEPENDENT FILTER LOGIC ---
      
      // Category check: If no category is selected in URL -> Default to true.
      // If selected, this item's ID must match one of the categories in the URL.
      const hasMatchingCategory = urlCategoryIds.length > 0 
        ? urlCategoryIds.some(id => fields.category?.includes(id)) 
        : true;

      // Brand check: Similar to above, the item must match one of the brands in the URL.
      const hasMatchingBrand = urlBrandIds.length > 0 
        ? urlBrandIds.some(id => fields.brand?.includes(id)) 
        : true;

      // Collect Brand: Only collect the brand if this item belongs to the categories being filtered in the URL
      if (fields.brand && hasMatchingCategory) {
        brands.add(fields.brand);
      }

      // Collect Category: Only collect the category if this item belongs to the brands being filtered in the URL
      if (fields.category && hasMatchingBrand) {
        categories.add(fields.category);
      }
    });
  }

  // Save and sort the lists
  filterOptions.brands = Array.from(brands).sort();
  filterOptions.categories = Array.from(categories).sort();

  // Initialize and map GIDs to display Titles
  filterOptions.brandLabels = {};
  filterOptions.categoryLabels = {};

  filterOptions.brands.forEach(brandGid => {
    filterOptions.brandLabels[brandGid] = brandMap[brandGid] || brandGid;
  });

  filterOptions.categories.forEach(categoryGid => {
    filterOptions.categoryLabels[categoryGid] = categoryMap[categoryGid] || categoryGid;
  });

  return Promise.resolve();
}

// Add utility function to manage the single loading container
const loadingManager = {
  show: (message = 'Loading promotions...') => {
    const container = document.querySelector('.bonus-offer__loading-container');
    if (container) {
      const messageElement = container.querySelector('p');
      if (messageElement) {
        messageElement.textContent = message;
      }
      container.style.display = 'flex';
      container.style.opacity = '1';
    }
  },

  hide: () => {
    const container = document.querySelector('.bonus-offer__loading-container');
    if (container) {
      container.style.opacity = '0';
      setTimeout(() => {
        container.style.display = 'none';
      }, 300);
    }
  }
};

// New function to process all metaobjects at once (replaces fetchAllMetaobjects)
async function processAllMetaobjects() {
  try {
    // Show loading using the single container
    loadingManager.show();

    // Process data from Liquid
    const data = processMetaobjectsData();

    if (!data || !data.metaobjects) {
      console.warn('No metaobjects data available');
      // Show empty state
      const listContainer = document.querySelector('.bonus-offer__list');
      if (listContainer) {
        listContainer.innerHTML = `
          <div class="no-results" style="display: flex; align-items: center; justify-content: center; padding: 40px;">
            <p>No promotions available at this time.</p>
          </div>
        `;
      }
      loadingManager.hide();
      return Promise.resolve(data);
    }

    // Landing page only shows offers in the active window:
    // hide before valid_from, and hide after expiry (cut_off is irrelevant here -
    // post-expiry redemption lives on the detail page).
    const currentDate = new Date();
    appState.allMetaobjects = (data.metaobjects.edges || []).filter(edge => {
      const metaobject = edge.node;
      
      // We keep the safety check for data structure, but remove the date filtering
      if (metaobject && metaobject.fields && Array.isArray(metaobject.fields)) {
        return true; 
      }
      return true;
    });
    appState.filteredMetaobjects = [...appState.allMetaobjects];

    // Extract filter options (this is async because it may fetch collection details)
    await extractFilterOptions(data.metaobjects);

    // Update total count
    storeInfo.totalItems = appState.allMetaobjects.length;

    // Add a small delay for better UX (simulate loading)
    return new Promise(resolve => {
      setTimeout(() => {
        loadingManager.hide();
        resolve(data.metaobjects);
      }, layoutConstants.loadingDelay);
    });
  } catch (error) {
    console.error('Error processing all metaobjects:', error);
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.innerHTML = `
        <div class="error-message" style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" fill="currentColor"/>
          </svg>
          <p>There was an error loading the promotions. Please try again later.</p>
        </div>
      `;
    }
    loadingManager.hide();
    throw error;
  }
}

function scrollToBonusOfferTop() {
  return new Promise((resolve) => {
    // If already at or very close to top
    if (window.scrollY <= 10) {
      resolve(true);
      return;
    }

    let isResolved = false;
    const finish = () => {
      if (!isResolved) {
        isResolved = true;
        window.removeEventListener('scrollend', finish);
        resolve(true);
      }
    };

    // Listen for scrollend event supported by modern browsers
    window.addEventListener('scrollend', finish, { once: true });

    // Fallback timer in case scrollend does not fire
    setTimeout(finish, 600);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

// Replace loadPage with improved version that handles clean URLs and smooth transitions
async function loadPage(page = 1, shouldScroll = true) {
  // Force page to be at least 1
  page = Math.max(1, page);

  // Save current page
  appState.currentPage = page;

  // Lock current listContainer height to avoid jerky layout collapse during transition
  const listContainer = document.querySelector('.bonus-offer__list');
  if (listContainer && listContainer.offsetHeight > 0) {
    listContainer.style.minHeight = `${listContainer.offsetHeight}px`;
  }

  // Show loading state before starting scroll & update
  loadingManager.show();

  // Wait until scrolling to top finishes before updating content
  if (shouldScroll) {
    await scrollToBonusOfferTop();
  }

  // Update URL to reflect current state - use clean IDs for URL
  const searchParams = new URLSearchParams();
  searchParams.set('page', page.toString());

  // Add filter params with clean IDs using comma-separated values
  Object.entries(appState.filters).forEach(([key, values]) => {
    if (values.length > 0) {
      // Use Set to avoid duplicates and join with commas
      const uniqueValues = [...new Set(values)];
      const cleanValues = uniqueValues.map(value => urlUtils.gidToCleanId(value));
      searchParams.set(key, cleanValues.join(','));
    }
  });

  window.history.replaceState({}, '', `?${searchParams.toString()}`);

  // Calculate pagination slices
  const startIndex = (page - 1) * appState.itemsPerPage;
  const endIndex = startIndex + appState.itemsPerPage;

  // Get current page items
  const pageItems = appState.filteredMetaobjects.slice(startIndex, endIndex);

  // Create page info for rendering pagination
  const pageInfo = {
    hasNextPage: endIndex < appState.filteredMetaobjects.length,
    hasPreviousPage: page > 1,
    startCursor: startIndex > 0 ? String(startIndex) : null,
    endCursor: endIndex < appState.filteredMetaobjects.length ? String(endIndex) : null
  };

  // Render the current page items
  if (pageItems.length === 0) {
    const contentContainer = document.querySelector('.bonus-offer__content');
    if (listContainer) {
      listContainer.innerHTML = `
        <div class="no-results">
          No promotions available.
        </div>
      `;
    }
    if (contentContainer) {
      contentContainer.classList.add('no-promotions');
    }
  } else {
    // Create a metaobjects structure similar to what the API would return
    const metaobjects = {
      edges: pageItems,
      pageInfo: pageInfo
    };

    renderMetaobjects(metaobjects);
  }
  // Always update statistics and pagination based on filteredMetaobjects length
  renderStatistics(appState.filteredMetaobjects.length, page);
  renderPagination(pageInfo, page);

  // Render the filter UI
  renderFilterUI(appState.filters);

  // Update filter visibility based on available offers
  toggleFilterVisibility();

  // Remove any filtering visual state
  if (listContainer) {
    listContainer.classList.remove('is-filtering');
  }

  // Hide loading
  loadingManager.hide();

  // Release minHeight smoothly after render
  if (listContainer) {
    listContainer.style.minHeight = '';
  }

  return true;
}

// Define applyFiltersWithDebounce ONCE - Remove all other declarations
const applyFiltersWithDebounce = utilityFunctions.debounce((expandedSections = {}) => {
  // Show loading with filter-specific message and ensure minimum visibility
  loadingManager.show();

  // Add visual feedback for filtering
  const listContainer = document.querySelector('.bonus-offer__list');
  if (listContainer) {
    listContainer.classList.add('is-filtering');
  }

  // Collect all checked brand filters
  const brandCheckboxes = document.querySelectorAll('input[name="brand"]:checked');
  const brandValues = [...new Set(Array.from(brandCheckboxes).map((cb) => cb.value))];

  // Collect all checked category filters
  const categoryCheckboxes = document.querySelectorAll('input[name="category"]:checked');
  const categoryValues = [...new Set(Array.from(categoryCheckboxes).map((cb) => cb.value))];

  // Update app state filters
  appState.filters = {
    brand: brandValues,
    category: categoryValues
  };

  // Apply filters to all metaobjects
  if (brandValues.length > 0 || categoryValues.length > 0) {
    appState.filteredMetaobjects = appState.allMetaobjects.filter((edge) => {
      const fields = {};

      // Create a map of fields for easy access
      if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
        edge.node.fields.forEach((field) => {
          if (field && field.key && field.value) {
            fields[field.key] = field.value;
          }
        });
      }

      // Check if this metaobject matches all active filters
      let matchesBrand = true;
      let matchesCategory = true;

      if (brandValues.length > 0) {
        matchesBrand = brandValues.includes(fields.brand);
      }

      if (categoryValues.length > 0) {
        matchesCategory = categoryValues.includes(fields.category);
      }

      return matchesBrand && matchesCategory;
    });
  } else {
    // No filters active, show all items
    appState.filteredMetaobjects = [...appState.allMetaobjects];
  }

  // Update URL with filters using clean IDs - start with fresh URLSearchParams
  const searchParams = new URLSearchParams();

  // Use Set to avoid duplicates, then add filter values to URL with clean IDs
  const uniqueBrands = [...new Set(brandValues)];
  const uniqueCategories = [...new Set(categoryValues)];

  // Add comma-separated values to URL
  if (uniqueBrands.length > 0) {
    const cleanBrands = uniqueBrands.map(brand => urlUtils.gidToCleanId(brand));
    searchParams.set('brand', cleanBrands.join(','));
  }

  if (uniqueCategories.length > 0) {
    const cleanCategories = uniqueCategories.map(category => urlUtils.gidToCleanId(category));
    searchParams.set('category', cleanCategories.join(','));
  }

  // Reset to page 1 when filters change
  searchParams.set('page', '1');
  appState.currentPage = 1;

  // Use replaceState instead of pushState to avoid adding to browser history on each filter
  window.history.replaceState({}, '', `?${searchParams.toString()}`);

  // Ensure minimum loading time for better UX and visual feedback
  setTimeout(() => {
    // Remove filtering visual state
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.classList.remove('is-filtering');
    }

    // Reload the first page with new filters, preserving expanded sections
    loadPage(1);

    // Update filter visibility based on available offers
    toggleFilterVisibility();

    // Restore expanded state after page load
    setTimeout(() => {
      const brandSection = document.getElementById('brand-filters');
      const categorySection = document.getElementById('category-filters');

      if (brandSection && expandedSections.brand) {
        brandSection.classList.add('show-all');
        const button = document.querySelector('button[data-target="brand-filters"]');
        if (button) button.classList.add('showing-all');
      }

      if (categorySection && expandedSections.category) {
        categorySection.classList.add('show-all');
        const button = document.querySelector('button[data-target="category-filters"]');
        if (button) button.classList.add('showing-all');
      }
    }, 10);
  }, 300); // Minimum loading time for better UX
}, 300); // 300ms debounce delay

// Replace the existing applyFilters function with the debounced version
function applyFilters(expandedSections = {}) {
  applyFiltersWithDebounce(expandedSections);
}

// This function starts the data processing as early as possible
function initiateEarlyDataProcessing() {
  // Start processing immediately and store the promise
  initialDataProcessing = processAllMetaobjects().catch(error => {
    console.error('Early data processing failed:', error);
    // We'll handle the error display when rendering
    return null;
  });
  return initialDataProcessing;
}

// Start the data processing immediately when the script loads
initiateEarlyDataProcessing();

// Update loadAllItems to handle comma-separated values
function loadAllItems() {
  const searchParams = new URLSearchParams(window.location.search);

  // Parse comma-separated filter parameters
  const brandFilters = searchParams.get('brand')?.split(',').filter(Boolean) || [];
  const categoryFilters = searchParams.get('category')?.split(',').filter(Boolean) || [];

  // Clear the params and rebuild them
  searchParams.delete('brand');
  searchParams.delete('category');
  searchParams.delete('page');

  // Set pageView=all
  searchParams.set('pageView', 'all');

  // Add back all filter parameters with clean IDs
  brandFilters.forEach(brand => {
    searchParams.append('brand', brand);
  });

  categoryFilters.forEach(category => {
    searchParams.append('category', category);
  });

  // Update URL with all parameters
  window.history.pushState({}, '', `?${searchParams.toString()}`);

  // // Show loading state
  loadingManager.show();

  // Apply a small delay to ensure loading indicator is visible
  setTimeout(() => {
    // Show all items without pagination
    if (appState.filteredMetaobjects.length === 0) {
      const listContainer = document.querySelector('.bonus-offer__list');
      if (listContainer) {
        listContainer.innerHTML = `
          <div class="no-results" style="display: flex; align-items: center; justify-content: center;">
            No promotions available.
          </div>
        `;
      }
      const contentContainer = document.querySelector('.bonus-offer__content');
      if (contentContainer) {
        contentContainer.classList.add('no-promotions');
      }
    } else {
      // Create a metaobjects structure for rendering
      const metaobjects = {
        edges: appState.filteredMetaobjects,
        pageInfo: {
          hasNextPage: false,
          hasPreviousPage: false
        }
      };

      renderMetaobjects(metaobjects);
    }

    // Always render statistics with accurate filtered count
    renderStatistics(appState.filteredMetaobjects.length, 'all');

    // Update filter visibility based on available offers
    toggleFilterVisibility();

    // Hide pagination
    const paginationContainer = document.querySelector('.bonus-offer__pagination');
    if (paginationContainer) {
      paginationContainer.style.display = 'none';
    }

    // Hide loading
    loadingManager.hide();
  }, 300); // Slight delay for better UX
}

// Update the DOMContentLoaded event handler to handle clean URLs from the browser
document.addEventListener('DOMContentLoaded', async () => {
  try {
    const container = document.querySelector('.bonus-offer__container');
    if (!container) {
      console.error('Container .bonus-offer__container not found');
      return;
    }

    // Get pagination setting from DOM
    const bonusOfferList = document.getElementById('bonus-offer__list');
    if (bonusOfferList) {
      const paginationSetting = bonusOfferList.getAttribute('data-pagination');
      if (paginationSetting) {
        appState.itemsPerPage = parseInt(paginationSetting, 12) || 5;
      }
    }

    // Check if pagination container exists, create if needed
    if (!document.querySelector('.bonus-offer__pagination')) {
      const paginationDiv = document.createElement('div');
      paginationDiv.classList.add('bonus-offer__pagination');
      container.appendChild(paginationDiv);
    }

    // Check if stats container exists, create if needed
    if (!document.querySelector('.bonus-offer__stats')) {
      const statsDiv = document.createElement('div');
      statsDiv.classList.add('bonus-offer__stats');

      // Insert stats before pagination
      const pagination = document.querySelector('.bonus-offer__pagination');
      if (pagination && pagination.parentNode) {
        pagination.parentNode.insertBefore(statsDiv, pagination);
      } else {
        // Fallback: append to container if pagination not found
        container.appendChild(statsDiv);
      }
    }

    // Check if filter container exists (it should already be in the HTML)
    // If not found, create it at the beginning of the container
    if (!document.querySelector('.bonus-offer__filter')) {
      const filterDiv = document.createElement('div');
      filterDiv.classList.add('bonus-offer__filter');

      // Insert as first child if container has children, otherwise just append
      if (container.firstChild) {
        container.insertBefore(filterDiv, container.firstChild);
      } else {
        container.appendChild(filterDiv);
      }
    }

    // Read URL params for initial state and convert clean IDs back to GIDs
    const searchParams = new URLSearchParams(window.location.search);
    appState.currentPage = parseInt(searchParams.get('page')) || 1;

    // Initialize filters from URL, handling comma-separated values
    const brandParam = searchParams.get('brand');
    const categoryParam = searchParams.get('category');

    appState.filters = {
      brand: brandParam ? brandParam.split(',').map(brand => urlUtils.cleanIdToBrandGid(brand)) : [],
      category: categoryParam ? categoryParam.split(',').map(category => urlUtils.cleanIdToCategoryGid(category)) : []
    };

    // Use the data that was already being processed
    let metaobjectsData;
    if (initialDataProcessing) {
      metaobjectsData = await initialDataProcessing;
    } else {
      // If for some reason the early processing didn't happen, do it now
      metaobjectsData = await processAllMetaobjects();
    }

    // IMPORTANT: First initialize the filter UI with the data, then apply any filters
    // Ensure all metaobjects are filtered properly based on URL parameters
    if (appState.filters.brand.length > 0 || appState.filters.category.length > 0) {
      // Apply the filters but don't re-render yet (we'll do that below)
      appState.filteredMetaobjects = appState.allMetaobjects.filter((edge) => {
        const fields = {};

        if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
          edge.node.fields.forEach((field) => {
            if (field && field.key && field.value) {
              fields[field.key] = field.value;
            }
          });
        }

        let matchesBrand = true;
        let matchesCategory = true;

        if (appState.filters.brand.length > 0) {
          matchesBrand = appState.filters.brand.includes(fields.brand);
        }

        if (appState.filters.category.length > 0) {
          matchesCategory = appState.filters.category.includes(fields.category);
        }

        return matchesBrand && matchesCategory;
      });
    } else {
      // No filters active, show all items
      appState.filteredMetaobjects = [...appState.allMetaobjects];
    }

    // Check if pageView=all is specified first
    if (searchParams.get('pageView') === 'all') {
      loadAllItems();
    } else {
      // Otherwise load the current page with filtered metaobjects
      loadPage(appState.currentPage);
    }

    // Always render the filter UI with the correct state, regardless of pageView mode
    renderFilterUI(appState.filters);

    // Initialize filter sections
    initializeFilterSections();

    // Hide filter if there are no offers
    toggleFilterVisibility();

  } catch (error) {
    console.error('Error during initialization:', error);
    document.querySelector('.bonus-offer__list').innerHTML = `
      <div class="error-message">
        There was an error initializing the page. Please try again later.<br>
      </div>
    `;
  }
});

function equalizeBonusOfferItemHeights() {
  const items = Array.from(document.querySelectorAll('.bonus-offer__item'));
  if (!items.length) return;

  // Determine items per row based on screen width
  let itemsPerRow = 3;
  const width = window.innerWidth;
  if (width < 750) {
    // Reset heights for mobile, no equalization
    items.forEach(item => {
      const title = item.querySelector('.bonus-offer__item--content-title');
      const desc = item.querySelector('.bonus-offer__basic-description');
      const end = item.querySelector('.bonus-offer__offer-end');
      if (title) title.style.minHeight = '';
      if (desc) desc.style.minHeight = '';
      if (end) end.style.minHeight = '';
    });
    return;
  } else if (width < 990) {
    itemsPerRow = 2;
  }

  // Reset heights first for all target elements
  items.forEach(item => {
    const title = item.querySelector('.bonus-offer__item--content-title');
    const desc = item.querySelector('.bonus-offer__basic-description');
    const end = item.querySelector('.bonus-offer__offer-end');
    if (title) title.style.minHeight = '';
    if (desc) desc.style.minHeight = '';
    if (end) end.style.minHeight = '';
  });

  // Group items per row and equalize heights
  for (let i = 0; i < items.length; i += itemsPerRow) {
    const rowItems = items.slice(i, i + itemsPerRow);

    let maxTitle = 0, maxDesc = 0, maxEnd = 0;
    rowItems.forEach(item => {
      const title = item.querySelector('.bonus-offer__item--content-title');
      const desc = item.querySelector('.bonus-offer__basic-description');
      const end = item.querySelector('.bonus-offer__offer-end');
      if (title) maxTitle = Math.max(maxTitle, title.offsetHeight);
      if (desc) maxDesc = Math.max(maxDesc, desc.offsetHeight);
      if (end) maxEnd = Math.max(maxEnd, end.offsetHeight);
    });

    rowItems.forEach(item => {
      const title = item.querySelector('.bonus-offer__item--content-title');
      const desc = item.querySelector('.bonus-offer__basic-description');
      const end = item.querySelector('.bonus-offer__offer-end');
      if (title) title.style.minHeight = maxTitle + 'px';
      if (desc) desc.style.minHeight = maxDesc + 'px';
      if (end) end.style.minHeight = maxEnd + 'px';
    });
  }
}

// Re-apply on window resize (debounced for performance)
window.addEventListener('resize', utilityFunctions.debounce(equalizeBonusOfferItemHeights, 200));

// Save current url to session storage

let currentScrollY = 0;
function saveCurrentUrlToSessionStorage(page) {
    currentScrollY = window.scrollY;
    const url = new URL(window.location.href);
    url.searchParams.set("page", page);
    window.history.pushState({ page, scrollY: currentScrollY }, "", url);
}

// Add utility function to hide/show filter based on filter options availability
function toggleFilterVisibility() {
  const filterElement = document.querySelector('.bonus-offer__filter');
  const filterToggleElement = document.querySelector('.bonus-offer__filter-toggle');

  if (!filterElement) return;

  // Check if there are any offers available (check all offers, not just filtered ones)
  const hasOffers = appState.allMetaobjects && appState.allMetaobjects.length > 0;

  // Check if there are any categories or brands available for filtering
  const hasBrands = filterOptions.brands && filterOptions.brands.length > 0;
  const hasCategories = filterOptions.categories && filterOptions.categories.length > 0;
  const hasFilterOptions = hasBrands || hasCategories;

  // Show filter only if there are offers AND there are filter options (brands or categories)
  if (hasOffers && hasFilterOptions) {
    filterElement.style.display = '';
    if (filterToggleElement) {
      filterToggleElement.style.display = '';
    }
  } else {
    filterElement.style.display = 'none';
    if (filterToggleElement) {
      filterToggleElement.style.display = 'none';
    }
  }
}

// Update renderPagination to work with client-side pagination
function renderPagination(pageInfo, currentPage) {
  const paginationContainer = document.querySelector('.bonus-offer__pagination');
  if (!paginationContainer) return;

  paginationContainer.innerHTML = '';
  paginationContainer.style.display = ''; // Show pagination by default

  // Calculate total pages
  const totalPages = Math.ceil(appState.filteredMetaobjects.length / appState.itemsPerPage);

  if (totalPages <= 1) {
    // Hide pagination if only one page
    paginationContainer.style.display = 'none';
    return;
  }

  // Create pagination container
  const paginationNav = document.createElement('nav');
  paginationNav.className = 'pagination';
  paginationNav.setAttribute('role', 'navigation');
  paginationNav.setAttribute('aria-label', 'Pagination');

  const paginationList = document.createElement('ul');
  paginationList.className = 'pagination-list';

  // Previous button
  if (currentPage > 1) {
    const prevItem = document.createElement('li');
    const prevLink = document.createElement('a');
    prevLink.className = 'pagination-previous';
    prevLink.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                              <mask id="mask0_4947_10945" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                                <rect y="0.277832" width="24" height="24" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_4947_10945)">
                                <path d="M9.95185 17.9315L4.29785 12.2778L9.95185 6.62402L11.0056 7.70852L7.18635 11.5278H19.7019V13.0278H7.18635L11.0056 16.847L9.95185 17.9315Z" fill="currentColor"/>
                              </g>
                            </svg>
                          `;
    prevLink.href = '#';
    prevLink.addEventListener('click', (e) => {
      e.preventDefault();
      saveCurrentUrlToSessionStorage(currentPage);
      loadPage(currentPage - 1, true);
    });
    prevItem.appendChild(prevLink);
    paginationList.appendChild(prevItem);
  }

  // Page numbers
  const startPage = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
  const endPage = Math.min(totalPages, Math.max(5, currentPage + 2));

  for (let i = startPage; i <= endPage; i++) {
    const pageItem = document.createElement('li');
    const pageLink = document.createElement('a');
    pageLink.className = 'pagination-link';
    pageLink.textContent = i.toString();
    if (i === currentPage) {
      pageLink.className += ' is-current';
      pageLink.setAttribute('aria-current', 'page');
    } else {
      pageLink.href = '#';
      pageLink.addEventListener('click', (e) => {
        e.preventDefault();
        saveCurrentUrlToSessionStorage(i);
        loadPage(i, true);
      });
    }

    pageItem.appendChild(pageLink);
    paginationList.appendChild(pageItem);
  }

  // Next button
  if (pageInfo.hasNextPage) {
    const nextItem = document.createElement('li');
    const nextLink = document.createElement('a');
    nextLink.className = 'pagination-next';
    nextLink.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                              <mask id="mask0_4947_10959" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                                <rect y="0.277832" width="24" height="24" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_4947_10959)">
                                <path d="M13.8462 17.9315L12.7923 16.847L16.6115 13.0278H4.5V11.5278H16.6115L12.7923 7.70852L13.8462 6.62402L19.5 12.2778L13.8462 17.9315Z" fill="currentColor"/>
                              </g>
                            </svg>
                          `;
    nextLink.href = '#';
    nextLink.addEventListener('click', (e) => {
      e.preventDefault();
      saveCurrentUrlToSessionStorage(currentPage);
      loadPage(currentPage + 1, true);
    });
    nextItem.appendChild(nextLink);
    paginationList.appendChild(nextItem);
  }

  paginationNav.appendChild(paginationList);
  paginationContainer.appendChild(paginationNav);
}

// Function to render rich text content
function renderRichText(richText) {
  try {
    if (!richText) return '';

    let richTextData;

    // Handle if the input is already an object
    if (typeof richText === 'object') {
      richTextData = richText;
    } else {
      // Try to parse as JSON
      try {
        richTextData = JSON.parse(richText);
      } catch (e) {
        // If not valid JSON, return as-is
        return String(richText);
      }
    }

    // Handle specific structure from the API
    if (richTextData && richTextData.type === 'root' && Array.isArray(richTextData.children)) {
      return richTextData.children.map(node => {
        // Handle paragraphs
        if (node.type === 'paragraph') {
          const content = (node.children || []).map(child => {
            // Handle text nodes
            if (child.type === 'text') {
              return child.value;
            }
            // Handle links
            else if (child.type === 'link' && child.url) {
              const linkText = (child.children || [])
                .map(linkChild => linkChild.value || '')
                .join('');
              return `<a href="${child.url}" target="_blank" rel="noopener">${linkText}</a>`;
            }
            return '';
          }).join('');

          return `<p>${content}</p>`;
        }
        // Handle headings
        else if (node.type && node.type.startsWith('heading')) {
          const level = node.depth || parseInt(node.type.charAt(node.type.length - 1)) || 2;
          const content = (node.children || [])
            .map(child => child.value || '')
            .join('');
          return `<h${level}>${content}</h${level}>`;
        }
        // Handle lists
        else if (node.type === 'list') {
          const listType = node.ordered ? 'ol' : 'ul';
          const listItems = (node.children || []).map(item => {
            if (item.type === 'listItem') {
              const itemContent = (item.children || [])
                .map(itemChild => {
                  if (itemChild.type === 'paragraph') {
                    return (itemChild.children || [])
                      .map(paraChild => paraChild.value || '')
                      .join('');
                  }
                  return '';
                })
                .join('');
              return `<li>${itemContent}</li>`;
            }
            return '';
          }).join('');
          return `<${listType}>${listItems}</${listType}>`;
        }

        return '';
      }).join('');
    }

    // Fallback to string representation
    return typeof richTextData === 'string'
      ? richTextData
      : JSON.stringify(richTextData);

  } catch (error) {
    console.warn('Error rendering rich text:', error);
    return String(richText || ''); // Safe fallback
  }
}

// Fix the formatDate function (remove duplicate)
function formatDate(dateString) {
  try {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  } catch (error) {
    console.warn('Error formatting date:', dateString, error);
    return dateString; // Return the original string if formatting fails
  }
}

// Add missing renderMetaobjects function
async function renderMetaobjects(metaobjects) {
  const data = processMetaobjectsData();
  if (data?.metaobjects) await extractFilterOptions(data.metaobjects);

  const container = document.querySelector('.bonus-offer__list');
  const contentContainer = document.querySelector('.bonus-offer__content');

  if (!container) {
    console.error('Could not find container element .bonus-offer__list');
    return;
  }

  if (!metaobjects || !metaobjects.edges || metaobjects.edges.length === 0) {
    container.innerHTML = '<div class="no-results">No promotions available.</div>';
    if (contentContainer) {
      contentContainer.classList.add('no-promotions');
    }
    return;
  }

  // Remove no-promotions class if it exists
  if (contentContainer) {
    contentContainer.classList.remove('no-promotions');
  }

  container.innerHTML = '';
  metaobjects.edges.forEach((edge, index) => {

    const metaobject = edge.node;
    const fields = {};

    if (!metaobject.fields || !Array.isArray(metaobject.fields)) {
      console.error(`Metaobject ${index + 1} has no fields array:`, metaobject);
      return;
    }

    metaobject.fields.forEach((field) => {
      if (!field || !field.key) {
        console.warn('Skipping invalid field:', field);
        return;
      }
      fields[field.key] = field.value;

      // Store the field type for special handling during rendering
      fields[`${field.key}_type`] = field.type;
    });

    function formatDate(dateString) {
      try {
        if(!dateString) return '';
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('en-GB', { month: 'long' });
        const year = date.getFullYear();

        // Helper for ordinal suffix
        function ordinal(n) {
          if (n > 3 && n < 21) return n + 'th';
          switch (n % 10) {
            case 1: return n + 'st';
            case 2: return n + 'nd';
            case 3: return n + 'rd';
            default: return n + 'th';
          }
        }

        return `${ordinal(day)} ${month} ${year}`;
      } catch (error) {
        console.warn('Error formatting date:', dateString, error);
        return dateString;
      }
    }

    // Render the metaobject item
    try {
      const itemHtml = `
        <div class="bonus-offer__item" data-id="${metaobject.id || ''}">
          <div class="bonus-offer__item--image">
            ${
        fields.image
          ? `<a href="${fields.url}" title="${
            fields.short_description || ''
          }" class="bonus-offer__item--image-link">
                    <img src="${fields.image}" alt="${fields?.imageAlt || ''}" width="100%" height="auto">
                  </a>`
          : `<a href="${fields.url}" title="${
            fields.short_description || ''
          }" class="bonus-offer__item--image-link"><div class="placeholder-svg"><svg class="placeholder-svg placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg></div></a>`
      }
          </div>
          <div class="bonus-offer__item--content">
            <p class="bonus-offer__item--content-title">
              <a href="${fields.url}">
                ${fields.short_description || 'Untitled Promotion'}
              </a>
            </p>

            <div class="bonus-offer__card-middle">
              <p class="bonus-offer__basic-description"> ${fields.basic_description || ''} </p>
              <p data-exprire="${fields.expiry}"class="bonus-offer__offer-end ${(fields.expiry_formatted || formatDate(fields.expiry)) || (fields.redemption_cut_off_formatted || formatDate(fields.redemption_cut_off)) ? 'valid-time' : ''} ">
                ${(fields.expiry_formatted || formatDate(fields.expiry)) ? '<span class="label"> Offer Ends: </span>' + (fields.expiry_formatted || formatDate(fields.expiry)) : ''}

                ${(fields.redemption_cut_off_formatted || formatDate(fields.redemption_cut_off)) ? '<span class="label redemption-cutoff--label"> Redemption Cut-Off: </span>' + (fields.redemption_cut_off_formatted || formatDate(fields.redemption_cut_off)) : ''}
              </p>

              <p class="bonus-offer__card-footer">
                <a href="${fields.url}" class="bonus-offer__item--content-cta">
                  More Info
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_10147_13157" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_10147_13157)">
                    <path d="M17.0788 12.5H5V11.5H17.0788L11.2865 5.70775L12 5L19 12L12 19L11.2865 18.2923L17.0788 12.5Z" fill="currentColor"/>
                    </g>
                    </svg>
                </a>
              </p>
              </div>

          </div>
        </div>
      `;
      container.innerHTML += itemHtml;
    } catch (error) {
      console.error(`Error rendering metaobject ${index + 1}:`, error);
    }
  });
  equalizeBonusOfferItemHeights();
}

// Add missing renderStatistics function
function renderStatistics(itemCount, currentPage) {
  let statsContainer = document.querySelector('.bonus-offer__stats');
  if (!statsContainer) {
    statsContainer = document.createElement('div');
    statsContainer.classList.add('bonus-offer__stats');
    const parentContainer = document.querySelector('.bonus-offer__bottom');
    const paginationDiv = document.querySelector('.bonus-offer__pagination');
    if (parentContainer && paginationDiv) {
      parentContainer.insertBefore(statsContainer, paginationDiv);
    }
  }

  // Use itemCount directly since it already contains the filtered count passed from loadPage/loadAllItems
  const displayCount = itemCount;

  // Determine if we should show the View All button
  const showViewAll =
    currentPage !== 'all' && // Not already in View All mode
    displayCount > appState.itemsPerPage; // Have more items than fit on one page

  // Update the UI with the correct count and conditionally show the view all button
  statsContainer.innerHTML = `
   ${showViewAll ? `
    <div class="bonus-offer__stats-actions">
      <button class="bonus-offer__view-all">
        <span>View all</span>
        ${displayCount > 0 ? `
          <div class="bonus-offer__stats-count">
            <span>${displayCount}</span> ${displayCount > 1 ? 'Promotions' : 'Promotion '}
          </div>
        ` : ''}
      </button>
    </div>
    ` : ''}
  `;

  let promotionCountSelector = document.querySelector('.bonus-offer__count-text'),
      promotionToolbarContainer = document.querySelector('.bonus-offer__action-toolbar');
  if (promotionCountSelector) {
    promotionCountSelector.innerHTML = `<span>${displayCount}</span> ${displayCount > 1 ? 'Promotions' : 'Promotion '}`;
    if (promotionToolbarContainer) {
      promotionToolbarContainer.style.display = 'flex';
    }
  }
  const viewAllButton = statsContainer.querySelector('.bonus-offer__view-all');
  if (viewAllButton) {
    viewAllButton.addEventListener('click', () => {
      loadAllItems();

      // Ensure filter UI is rendered after switching to "View All" mode
      setTimeout(() => {
        renderFilterUI(appState.filters);
      }, 300);
    });
  }
}

// Add a function to count items per filter value (Updated with URL context)
function countItemsPerFilterValue() {
  const brandCounts = {};
  const categoryCounts = {};

  // 1. Get string values from URL Params and convert into arrays of IDs
  const urlParams = new URLSearchParams(window.location.search);
  const urlCategoryRaw = urlParams.get('category');
  const urlBrandRaw = urlParams.get('brand');

  const urlCategoryIds = urlCategoryRaw ? urlCategoryRaw.split(',') : [];
  const urlBrandIds = urlBrandRaw ? urlBrandRaw.split(',') : [];

  // Initialize all possible values with zero counts
  filterOptions.brands.forEach((brand) => (brandCounts[brand] = 0));
  filterOptions.categories.forEach((category) => (categoryCounts[category] = 0));

  // Count occurrences in all metaobjects
  appState.allMetaobjects.forEach((edge) => {
    const fields = {};

    // Safety check to ensure fields exists and is an array
    if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
      edge.node.fields.forEach((field) => {
        fields[field.key] = field.value;
      });
    }

    // --- NEW URL PARAM CHECK LOGIC ---
    // Check if this item matches the category and brand specified in the URL
    const matchesUrlCategory = urlCategoryIds.length > 0 
      ? urlCategoryIds.some(id => fields.category?.includes(id)) 
      : true;

    const matchesUrlBrand = urlBrandIds.length > 0 
      ? urlBrandIds.some(id => fields.brand?.includes(id)) 
      : true;

    // --- INCREMENT COUNTS ONLY FOR MATCHING ITEMS ---
    
    // Count Brands: Only count if the item matches the active URL category filter
    if (fields.brand && brandCounts.hasOwnProperty(fields.brand) && matchesUrlCategory) {
      brandCounts[fields.brand]++;
    }

    // Count Categories: Only count if the item matches the active URL brand filter
    if (fields.category && categoryCounts.hasOwnProperty(fields.category) && matchesUrlBrand) {
      categoryCounts[fields.category]++;
    }
  });

  return { brandCounts, categoryCounts };
}

// Update the generateFilterOptions function to include counts
function generateFilterOptions(options, values, labels, counts, type, enableSlider = false) {
  let optionsHtml = '';
  const MAX_VISIBLE_OPTIONS = 5;
  options.forEach((option, index) => {
    const isVisible = index < MAX_VISIBLE_OPTIONS ? '' : 'hidden-option';
    // Get the count for this option, default to 0 if missing
    const count = counts[option] || 0;

    // Ensure option is a string for HTML generation
    const optionStr = String(option);
    const safeId = optionStr.replace(/\//g, '-').replace(/\s+/g, '-').toLowerCase();

    optionsHtml += `
      <div class="g-checkbox bonus-offer__filter-option ${enableSlider ? 'swiper-slide' : ''} ${isVisible}" data-filter-idx="${index}">
        <input type="checkbox" id="${type}-${safeId}"
          name="${type}" value="${option}" ${values.includes(option) ? 'checked' : ''}>
        <label for="${type}-${safeId}">
          ${labels[option] || `Unknown ${type.charAt(0).toUpperCase() + type.slice(1)}`}
          <span class="bonus-offer__filter-count">${count}</span>
        </label>
      </div>
    `;
  });

  // Add a "Show All" button if there are more than MAX_VISIBLE_OPTIONS
  if (options.length > MAX_VISIBLE_OPTIONS && enableSlider === false) {
    optionsHtml += `
      <div class="bonus-offer__filter-show-more">
        <button type="button" class="bonus-offer__filter-show-all" data-target="${type}-filters">
          <span class="show-text">Show All</span>
          <span class="hide-text">Show Less</span>
        </button>
      </div>
    `;
  }

  return optionsHtml;
}

// Update renderFilterUI to use the counts and preserve expanded state
function renderFilterUI(currentFilters = {}) {
  // Track which filter sections are expanded
  const expandedSections = {};

  // Store the current expansion state before re-rendering
  const brandFiltersElement = document.getElementById('brand-filters');
  const categoryFiltersElement = document.getElementById('category-filters');

  if (brandFiltersElement) {
    expandedSections.brand = brandFiltersElement.classList.contains('show-all');
  }
  if (categoryFiltersElement) {
    expandedSections.category = categoryFiltersElement.classList.contains('show-all');
  }

  const filterContainer = document.querySelector('.bonus-offer__filter');
  if (!filterContainer) {
    console.error('Filter container not found');
    return;
  }

  // Check if mobile filter toggle button exists, create if not
  if (!document.querySelector('.bonus-offer__filter-toggle')) {
    const filterToggle = document.createElement('button');
    filterToggle.className = 'bonus-offer__filter-toggle';
    filterToggle.innerHTML = `<span class="icon-filter">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 20.5V15.5H12.5V17.5H20.5V18.5H12.5V20.5H11.5ZM3.5 18.5V17.5H8.5V18.5H3.5ZM7.5 14.5V12.5H3.5V11.5H7.5V9.5H8.5V14.5H7.5ZM11.5 12.5V11.5H20.5V12.5H11.5ZM15.5 8.5V3.5H16.5V5.5H20.5V6.5H16.5V8.5H15.5ZM3.5 6.5V5.5H12.5V6.5H3.5Z" />
      </svg>
      </span><span>Filter</span>`;
    filterToggle.setAttribute('aria-label', 'Toggle filter options');

    // Insert the toggle button at the top of the content
    const contentContainer = document.querySelector('.bonus-offer__action-toolbar');
    if (contentContainer) {
      contentContainer.insertAdjacentElement('afterbegin', filterToggle);
    } else {
      // Fallback: insert before filter container
      filterContainer.parentNode.insertBefore(filterToggle, filterContainer);
    }

    // Add event listener to toggle the filter panel
    filterToggle.addEventListener('click', toggleFilterPanel);
  }

  let inputBrandSearch = document.createElement('input');
    inputBrandSearch.type = 'text';
    inputBrandSearch.id = 'brands-search-input';
    inputBrandSearch.className = 'bonus-offer__brands-search-input';
    inputBrandSearch.placeholder = 'Filter Brands';
    inputBrandSearch.setAttribute('aria-label', 'Filter Brand');

  // Convert string filter values to arrays if needed
  const brandFilters = currentFilters.brand
    ? Array.isArray(currentFilters.brand)
      ? currentFilters.brand
      : [currentFilters.brand]
    : [];

  const categoryFilters = currentFilters.category
    ? Array.isArray(currentFilters.category)
      ? currentFilters.category
      : [currentFilters.category]
    : [];

  // Check if any filters are active
  const hasActiveFilters = brandFilters.length > 0 || categoryFilters.length > 0;

  // Get counts for all filter values
  const { brandCounts, categoryCounts } = countItemsPerFilterValue();

  function generateCategoryFilterHtmlWithAll(categories, selectedCategories, labels, counts) {
    let html = `
      <div class="g-checkbox bonus-offer__filter-option swiper-slide">
        <input type="checkbox" id="category-all" name="category-all" value="all" ${selectedCategories.length === 0 ? 'checked' : ''}>
        <label for="category-all">All</label>
      </div>
    `;
    html += generateFilterOptions(categories, selectedCategories, labels, counts, 'category', true);
    return html;
  }
  const categoryFilterHtml = generateCategoryFilterHtmlWithAll(
      filterOptions.categories,
      categoryFilters,
      filterOptions.categoryLabels,
      categoryCounts,
      'category'
  );
  const categoryFilterElement = document.querySelector('.bonus-offer-category--filter');
if (categoryFilterElement) {
  categoryFilterElement.innerHTML = categoryFilterHtml;
  categoryFilterElement.closest('.bonus-offer-category--wrapper')?.classList.add('categories-loaded');
  // Restore expanded state
  if (expandedSections.category) {
    categoryFilterElement.classList.add('show-all');
  } else {
    categoryFilterElement.classList.remove('show-all');
  }
  if (window?.Swiper) {
      const swiperEl = document.querySelector('.bonus-offer-category--wrapper');

      if (!swiperEl) return;

      const initSwiper = () => {
          const isMobile = window.innerWidth < 750;

          if (isMobile) {
              if (!window.categorySwiper) {
                  window.categorySwiper = new Swiper(swiperEl, {
                      loop: false,
                      simulateTouch: true,
                      slidesPerView: 'auto',

                      navigation: {
                          nextEl: swiperEl.querySelector('.swiper-button-next'),
                          prevEl: swiperEl.querySelector('.swiper-button-prev'),
                      },
                  });
              }
          } else {
              if (window.categorySwiper) {
                  window.categorySwiper.destroy(true, true);
                  window.categorySwiper = null;
              }
          }
      };

      initSwiper();

      window.addEventListener('resize', initSwiper);
  }

  // "All" checkbox logic
  const allCheckbox = categoryFilterElement.querySelector('input[name="category-all"]');
  const categoryCheckboxes = categoryFilterElement.querySelectorAll('input[type="checkbox"][name="category"]');

  if (allCheckbox) {
    allCheckbox.addEventListener('change', utilityFunctions.throttle(() => {
      if (allCheckbox.checked) {
        categoryCheckboxes.forEach(cb => cb.checked = false);
        appState.filters.category = [];
        applyFilters();
        renderFilterUI(appState.filters);
      } else {
        allCheckbox.checked = true;
      }
    }, 200));
  }

  categoryCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', utilityFunctions.throttle((e) => {
      const currentCheckbox = e.target;

      if (currentCheckbox.checked) {
        if (allCheckbox) allCheckbox.checked = false;

        categoryCheckboxes.forEach(cb => {
          if (cb !== currentCheckbox) cb.checked = false;
        });

        appState.filters.category = [currentCheckbox.value];
      } else {
        if (allCheckbox) allCheckbox.checked = true;
        appState.filters.category = [];
      }

      applyFilters();
      renderFilterUI(appState.filters);
    }, 200));
  });
}
  // Create the filter HTML structure with Apply button for mobile and toggleable sections
  filterContainer.innerHTML = `
    <div class="bonus-offer__filter-header">
      <h4 class="bonus-offer__filter-title">Filters</h4>
      <button class="bonus-offer__filter-close" aria-label="Close filter panel">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <mask id="mask0_5017_7902" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
            <rect x="0.5" width="24" height="24" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_5017_7902)">
            <path d="M12.5 13.0538L7.42701 18.127C7.28851 18.2653 7.11443 18.3362 6.90476 18.3395C6.69526 18.3427 6.51801 18.2718 6.37301 18.127C6.22818 17.982 6.15576 17.8063 6.15576 17.6C6.15576 17.3937 6.22818 17.218 6.37301 17.073L11.4463 12L6.37301 6.92701C6.23468 6.78851 6.16385 6.61443 6.16051 6.40476C6.15735 6.19526 6.22818 6.01801 6.37301 5.87301C6.51801 5.72818 6.69368 5.65576 6.90001 5.65576C7.10635 5.65576 7.28201 5.72818 7.42701 5.87301L12.5 10.9463L17.573 5.87301C17.7115 5.73468 17.8856 5.66385 18.0953 5.66051C18.3048 5.65735 18.482 5.72818 18.627 5.87301C18.7718 6.01801 18.8443 6.19368 18.8443 6.40001C18.8443 6.60635 18.7718 6.78201 18.627 6.92701L13.5538 12L18.627 17.073C18.7653 17.2115 18.8362 17.3856 18.8395 17.5953C18.8427 17.8048 18.7718 17.982 18.627 18.127C18.482 18.2718 18.3063 18.3443 18.1 18.3443C17.8937 18.3443 17.718 18.2718 17.573 18.127L12.5 13.0538Z" fill="currentColor"/>
          </g>
        </svg>
      </button>
    </div>
    <div class="bonus-offer__filter-content">
    <div class="bonus-offer__filter-section section-categories">
        <div class="bonus-offer__filter-section-header" data-target="category-filters">
          <label class="bonus-offer__filter-section-title">Category</label>
          <span class="bonus-offer__filter-section-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <mask id="mask0_4947_15222" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                <rect y="0.5" width="24" height="24" fill="currentColor"/>
              </mask>
              <g mask="url(#mask0_4947_15222)">
                <path d="M11.9999 10.9538L7.39994 15.5538L6.34619 14.5L11.9999 8.84625L17.6537 14.5L16.5999 15.5538L11.9999 10.9538Z" fill="currentColor"/>
              </g>
            </svg>
          </span>
        </div>
        <div class="bonus-offer__filter-options" id="category-filters">
          ${generateFilterOptions(
      filterOptions.categories,
      categoryFilters,
      filterOptions.categoryLabels,
      categoryCounts,
      'category'
  )}
        </div>
      </div>
      <div class="bonus-offer__filter-section">
        <div class="bonus-offer__filter-section-header" data-target="brand-filters">
          <label class="bonus-offer__filter-section-title">Brand</label>
          <span class="bonus-offer__filter-section-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <mask id="mask0_4947_15222" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                <rect y="0.5" width="24" height="24" fill="currentColor"/>
              </mask>
              <g mask="url(#mask0_4947_15222)">
                <path d="M11.9999 10.9538L7.39994 15.5538L6.34619 14.5L11.9999 8.84625L17.6537 14.5L16.5999 15.5538L11.9999 10.9538Z" fill="currentColor"/>
              </g>
            </svg>
          </span>
        </div>
        <div class="bonus-offer__filter-options" id="brand-filters">
          <div class="bonus-offer__brands-search">
            <label for="brands-search-input" class="bonus-offer__brands-search-label">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.4844 20.154L13.2229 13.8925C12.7229 14.3182 12.1479 14.6477 11.4979 14.881C10.8479 15.1144 10.1947 15.231 9.53837 15.231C7.9367 15.231 6.58112 14.6766 5.47162 13.5678C4.36228 12.4589 3.80762 11.1042 3.80762 9.50353C3.80762 7.9027 4.36203 6.54678 5.47087 5.43578C6.5797 4.32495 7.93445 3.76953 9.53512 3.76953C11.136 3.76953 12.4919 4.3242 13.6029 5.43353C14.7137 6.54303 15.2691 7.89861 15.2691 9.50028C15.2691 10.1951 15.146 10.8675 14.8999 11.5175C14.6537 12.1675 14.3306 12.7233 13.9306 13.1848L20.1921 19.4465L19.4844 20.154ZM9.53837 14.231C10.8652 14.231 11.9854 13.7743 12.8989 12.8608C13.8124 11.9474 14.2691 10.8273 14.2691 9.50028C14.2691 8.17328 13.8124 7.05311 12.8989 6.13978C11.9854 5.22628 10.8652 4.76953 9.53837 4.76953C8.21137 4.76953 7.0912 5.22628 6.17787 6.13978C5.26437 7.05311 4.80762 8.17328 4.80762 9.50028C4.80762 10.8273 5.26437 11.9474 6.17787 12.8608C7.0912 13.7743 8.21137 14.231 9.53837 14.231Z" />
              </svg>
            </label>
            ${inputBrandSearch.outerHTML}
          </div>
          ${generateFilterOptions(filterOptions.brands, brandFilters, filterOptions.brandLabels, brandCounts, 'brand', false)}
        </div>
      </div>

      <div class="bonus-offer__filter-actions ${hasActiveFilters ? 'show' : ''}">
        <button type="button" class="bonus-offer__filter-apply button button--primary">Apply</button>
        <button type="button" class="bonus-offer__filter-clear button button--small button--primary">Clear Filters</button>
      </div>
    </div>
  `;

  // Add event listeners to checkboxes (don't auto-apply on mobile)
  const checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');

  // For desktop, we'll keep the auto-filter behavior but preserve expanded state
  if (window.innerWidth > 768) {
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', utilityFunctions.throttle(() => {
        // Store current expanded state before applying filters
        const brandSection = document.getElementById('brand-filters');
        const categorySection = document.getElementById('category-filters');

        if (brandSection) {
          expandedSections.brand = brandSection.classList.contains('show-all');
        }
        if (categorySection) {
          expandedSections.category = categorySection.classList.contains('show-all');
        }

        // Apply filters with throttling
        applyFilters(expandedSections);
      }, 200)); // 200ms throttle
    });
  }
  // Clear filters button
  const clearButton = filterContainer.querySelector('.bonus-offer__filter-clear');
  clearButton.addEventListener('click', () => {
    // Show loading for clear action with visual feedback
    loadingManager.show();

    // Add visual feedback for filtering
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.classList.add('is-filtering');
    }

    // Uncheck all filter checkboxes
    const allCheckboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
    allCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });

    // Reset filters in app state
    appState.filters = {
      brand: [],
      category: []
    };

    // Reset to all metaobjects
    appState.filteredMetaobjects = [...appState.allMetaobjects];

    // Update URL without reloading the page - use clean URL format
    const searchParams = new URLSearchParams();
    searchParams.set('page', '1');
    window.history.pushState({}, '', `?${searchParams.toString()}`);

    // Reset to page 1 and reload content with smooth transition
    appState.currentPage = 1;

    // Use setTimeout to ensure smooth transition and minimum loading visibility
    setTimeout(() => {
      // Remove filtering visual state
      if (listContainer) {
        listContainer.classList.remove('is-filtering');
      }

      loadPage(1);

      // Close filter panel on mobile
      if (window.innerWidth <= 768) {
        toggleFilterPanel(null, false);
      }
    }, 600); // Increased delay to ensure loading spinner is visible
  });
  // Apply filters button (mainly for mobile)
  const applyButton = filterContainer.querySelector('.bonus-offer__filter-apply');
  applyButton.addEventListener('click', () => {
    // Show loading before applying filters
    loadingManager.show();

    // Add visual feedback
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.classList.add('is-filtering');
    }

    // Apply filters with a slight delay to ensure loading is visible
    setTimeout(() => {
      applyFilters();
      toggleFilterPanel(null, false); // Close the panel after applying
    }, 200);
  });

  // Close button
  const closeButton = filterContainer.querySelector('.bonus-offer__filter-close');
  closeButton.addEventListener('click', () => {
    toggleFilterPanel(null, false); // Force close
  });

  // Add event listeners to section headers to toggle content
  const sectionHeaders = filterContainer.querySelectorAll('.bonus-offer__filter-section-header');
  sectionHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      toggleFilterSection(header);
    });
  });

  // Add event listeners to "Show All" buttons
  const showAllButtons = filterContainer.querySelectorAll('.bonus-offer__filter-show-all');
  showAllButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const targetId = this.getAttribute('data-target');
      const optionsContainer = document.getElementById(targetId);

      if (!optionsContainer) return;

      const isExpanded = optionsContainer.classList.contains('show-all');

      if (isExpanded) {
        // Hide extra options
        optionsContainer.classList.remove('show-all');
        this.classList.remove('showing-all');
      } else {
        // Show all options
        optionsContainer.classList.add('show-all');
        this.classList.add('showing-all');
      }
    });
  });

  // Restore expanded state
  setTimeout(() => {
    const brandSection = document.getElementById('brand-filters');
    const categorySection = document.getElementById('category-filters');

    if (brandSection && expandedSections.brand) {
      brandSection.classList.add('show-all');
      const button = filterContainer.querySelector('button[data-target="brand-filters"]');
      if (button) button.classList.add('showing-all');
    }

    if (categorySection && expandedSections.category) {
      categorySection.classList.add('show-all');
      const button = filterContainer.querySelector('button[data-target="category-filters"]');
      if (button) button.classList.add('showing-all');
    }
  }, 0);

  let inputBrandHTML = filterContainer.querySelector('#brands-search-input'),
      showMoreBtn = filterContainer.querySelector('#brand-filters .bonus-offer__filter-show-more'),
      brandOptions = filterContainer.querySelectorAll('#brand-filters .bonus-offer__filter-option');
   inputBrandHTML.addEventListener('input', function() {
    const MAX_VISIBLE_OPTIONS = 5;
    utilityFunctions.debounce(() => {
      const searchTerm = this.value.toLowerCase();
      let visibleCount = 0;
      brandOptions.forEach((option, index) => {
        const isVisible = index < MAX_VISIBLE_OPTIONS ? '' : 'hidden-option';
        const label = option.querySelector('label');
        if (label && searchTerm) {
          const labelText = label.childNodes[0].textContent.toLowerCase().trim();
          if (labelText.includes(searchTerm)) {
            option.classList.add('matched');
            option.classList.remove('no-matched');
            visibleCount++;
          } else {
            option.classList.remove('matched')
            option.classList.add('no-matched')
          }
        }
        else {
          option.classList.remove('matched');
          option.classList.remove('no-matched')
        }
      });
      if (searchTerm) {
        // Limit the number of visible options
        if (visibleCount >= MAX_VISIBLE_OPTIONS && searchTerm) {
          showMoreBtn.style.display = 'block';
        } else {
          showMoreBtn.style.display = 'none';
        }
      } else {
        showMoreBtn.style.display = 'block';
      }

    }, 300)();
  });
  updateFilterPanelState();
}

// Function to toggle filter section visibility
function toggleFilterSection(headerElement) {
  const targetId = headerElement.getAttribute('data-target');
  const targetSection = document.getElementById(targetId);

  if (!targetSection) return;

  const isCollapsed = targetSection.classList.contains('collapsed');
  const toggleIcon = headerElement.querySelector('.bonus-offer__filter-section-toggle');

  // Store SVG icons for expand/collapse states
  const expandIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <mask id="mask0_4947_15222" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
    <rect y="0.5" width="24" height="24" fill="currentColor"/>
  </mask>
  <g mask="url(#mask0_4947_15222)">
    <path d="M11.9999 10.9538L7.39994 15.5538L6.34619 14.5L11.9999 8.84625L17.6537 14.5L16.5999 15.5538L11.9999 10.9538Z" fill="currentColor"/>
  </g>
</svg>`;

  const collapseIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1306_29627" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="-1" width="24" height="25">
      <rect y="-0.5" width="24" height="24" fill="currentColor"/>
    </mask>
    <g mask="url(#mask0_1306_29627)">
      <path d="M11.9999 9.95375L7.39994 14.5538L6.34619 13.5L11.9999 7.84625L17.6537 13.5L16.5999 14.5538L11.9999 9.95375Z" fill="currentColor"/>
    </g>
  </svg>`;

  if (isCollapsed) {
    // Expand the section
    targetSection.classList.remove('collapsed');
    headerElement.setAttribute('aria-expanded', 'true');
    if (toggleIcon) {
      toggleIcon.innerHTML = expandIcon;
      toggleIcon.setAttribute('aria-label', 'Collapse section');
    }
  } else {
    // Collapse the section
    targetSection.classList.add('collapsed');
    headerElement.setAttribute('aria-expanded', 'false');
    if (toggleIcon) {
      toggleIcon.innerHTML = collapseIcon;
      toggleIcon.setAttribute('aria-label', 'Expand section');
    }
  }
}

// Function to toggle filter panel visibility
function toggleFilterPanel(event, forceState) {
  // If force state is provided, use it; otherwise toggle current state
  uiState.isFilterOpen = forceState !== undefined ? forceState : !uiState.isFilterOpen;
  updateFilterPanelState();

  // If opening the panel, create an overlay
  if (uiState.isFilterOpen) {
    createFilterOverlay();
  } else {
    removeFilterOverlay();
  }
}

// Function to update the filter panel state based on uiState
function updateFilterPanelState() {
  const filterContainer = document.querySelector('.bonus-offer__filter');
  const body = document.body;

  if (uiState.isFilterOpen) {
    filterContainer.classList.add('is-active');
    body.classList.add('filter-open'); // Prevent scrolling
  } else {
    filterContainer.classList.remove('is-active');
    body.classList.remove('filter-open');
  }
}

// Create overlay when filter is open on mobile
function createFilterOverlay() {
  // Remove existing overlay if any
  removeFilterOverlay();

  // Create new overlay
  const overlay = document.createElement('div');
  overlay.className = 'bonus-offer__filter-overlay';
  overlay.addEventListener('click', () => {
    toggleFilterPanel(null, false); // Close panel when overlay is clicked
  });

  document.body.appendChild(overlay);

  // Animate in
  setTimeout(() => {
    overlay.classList.add('is-active');
  }, 10);
}

// Remove overlay
function removeFilterOverlay() {
  const overlay = document.querySelector('.bonus-offer__filter-overlay');
  if (overlay) {
    overlay.classList.remove('is-active');
    // Wait for animation before removing
    setTimeout(() => {
      overlay.parentNode.removeChild(overlay);
    }, 300);
  }
}

// Function to initialize filter sections
function initializeFilterSections() {
  const sectionHeaders = document.querySelectorAll('.bonus-offer__filter-section-header');

  sectionHeaders.forEach(header => {
    const targetId = header.getAttribute('data-target');
    const targetSection = document.getElementById(targetId);

    if (targetSection) {
      // Set initial state
      header.setAttribute('aria-expanded', 'true');
      targetSection.classList.remove('collapsed');

      // Add click handler
      header.addEventListener('click', () => toggleFilterSection(header));
    }
  });
}

// Loadpage when have session in state
window.addEventListener("popstate", (event) => {
    const url = new URL(window.location.href);
    const page = Number(url.searchParams.get("page")) || 1;
    loadPage(page).then(() => {
        window.scrollTo(0, currentScrollY);
    });
});
